export const usersApiEndpoints = {
  getUsers: (page: number, limit: number) =>
    `/users?page=${page}&limit=${limit}`,
  getUserReservations: (
    userId: string,
    event: string,
    page: number,
    limit: number
  ) =>
    `/user-reservations/${userId}?event=${event}&page=${page}&limit=${limit}`,
  suspendUser: (userId: string) => `/users/${userId}/suspend`,
  reactivateUser: (userId: string) => `/users/${userId}/reactivate`,
};
